<template>
  <div>
    <!--数据导入-->
    <!-- <div class="content">
      <div class="title">
        <i class="el-icon-tickets" style="margin-right: 10px;color: #333"></i>数据导入
      </div>
      <div class="item-content">
        <div class="item" @click="toImportCustomerData">
          <img src="../../assets/images/icn-01.png" alt="客户导入">
          <p>客户</p>
        </div>
        <div class="item" @click="toEasyOrderData">
          <img src="../../assets/images/icn-02.png" alt="管易订单">
          <p>管易订单</p>
        </div>
      </div>
    </div> -->
    <!--数据导出-->
    <div class="content">
      <div class="title">
        <i class="el-icon-document" style="margin-right: 10px;color: #333"></i>数据导出
      </div>
      <div class="item-content">
        <div class="item" @click="toExportCustomerData('customer')">
          <img src="../../assets/images/icn-03.png" alt="数据导出">
          <p>受众导出</p>
        </div>
        <div class="item" @click="toExportCustomerData('order')">
          <img src="../../assets/images/icn-04.png" alt="数据导出">
          <p>订单导出</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dataInoutNav',
  data () {
    return {}
  },
  computed: {

  },
  methods: {
    // 跳转到客户导入
    toImportCustomerData() {
      router.push('/home/import-data')
    },
    // 跳转管易订单
    toEasyOrderData() {
      router.push('/home/easy-order')
    },
    // 跳转到客户导出
    toExportCustomerData(type) {
      if(type === 'order') {
        router.push({ path: '/home/export-data-order', query: { type: type }})
      } else {
        router.push({ path: '/home/export-data', query: { type: type }})
      }
    },
  },
  watch: {
  },
  created() {
  }
}
</script>

<style scoped>
  .content{
    width: calc(100% - 40px);
    margin: 0 auto 0;
  }
  .title{
    width: calc(100% - 10px);
    height: 48px;
    line-height: 48px;
    color: #333;
    font-size: 14px;
    text-align: left;
    padding-left: 10px;
    background: #F0F2F5;
  }
  .item-content{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .item{
    width: 380px;
    height: 200px;
    background: #fff;
    border:1px solid #E7E7E7;
    margin-left: 20px;
    cursor: pointer;
  }
  .item:first-child{
    margin-left: 0;
  }
  .item img{
    width: 68px;
    height: 68px;
    display: block;
    margin: 43px auto 18px;
  }
  .item p{
    color: #333;
    font-size: 20px;
    margin: 0;
    font-weight: bold;
    line-height: 28px;
  }
</style>
